var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { from, merge, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, map, mergeMap, switchMap,
// tap,
 } from 'rxjs/operators';
import { useObservable } from 'rxjs-hooks';
export var now = function () { return new Date().getTime(); };
export function IncrementalSearch(_a) {
    var inputValue = _a.inputValue, search = _a.search, submit$ = _a.submit$, children = _a.children, searchWaitMs = _a.searchWaitMs;
    var data = useObservable(function (_, inputValue$) {
        return merge(inputValue$.pipe(map(function (v) { return v[0]; }), filter(function (v) { return !!v && v.length > 1; }), distinctUntilChanged(), 
        // tap(v => console.log('input4', v)),
        debounceTime(searchWaitMs), 
        // tap(v => console.log('input5', v)),
        map(function (v) { return ({ value: v, time: now() }); })), submit$.pipe(
        // tap(v => console.log('submit1', v)),
        filter(function (v) { return typeof v !== 'undefined'; }), 
        // tap(v => console.log('submit2', v)),
        distinctUntilChanged(), 
        // tap(v => console.log('submit3', v)),
        mergeMap(function () { return inputValue$.pipe(map(function (v) { return ({ value: v[0], time: now() }); })); }))).pipe(distinctUntilChanged(function (a, b) { return a.time === b.time && a.value === b.value; }), map(function (_a) {
            var value = _a.value;
            return ({
                search: search(value),
                inputValue: value,
            });
        }), 
        // tap(v => console.log('before query', v)),
        switchMap(function (_a) {
            var search = _a.search, inputValue = _a.inputValue;
            return from(search).pipe(map(function (res) { return ({ result: res, inputValue: inputValue }); }));
        }), 
        // tap(v => console.log('after query', v)),
        map(function (_a) {
            var result = _a.result;
            return __assign(__assign({}, result), { done: true });
        }), catchError(function (_) { return of({ data: { queryFAQ: [] }, done: true, error: true }); }));
    }, { data: { queryFAQ: [] }, done: false }, [inputValue]);
    return children(data);
}
//# sourceMappingURL=IncrementalSearch.js.map